import React, { Component, ComponentType } from 'react';

import i18n from '@/content';

interface WithTranslationState {
    language: string;
}

/**
 * HOC to make class components reactive to language changes.
 * Wraps a class component and forces it to re-render when the i18n language changes.
 */
export function withTranslation<P extends object>(
    WrappedComponent: ComponentType<P>,
): ComponentType<P> {
    return class WithTranslation extends Component<P, WithTranslationState> {
        constructor(props: P) {
            super(props);
            this.state = {
                language: i18n.language,
            };
        }

        componentDidMount(): void {
            i18n.on('languageChanged', this.handleLanguageChange);
        }

        componentWillUnmount(): void {
            i18n.off('languageChanged', this.handleLanguageChange);
        }

        handleLanguageChange = (lng: string): void => {
            this.setState({ language: lng });
        };

        render(): JSX.Element {
            return <WrappedComponent {...this.props} />;
        }
    };
}

